import { LogReporterMessage, ToReport } from './interfaces';
import { ReporterMessage } from '../../../log';

export interface LogReportInterface {
  count?: number;
  data: string[];
  key: string;
  last?: number;
  level: string;
  ts?: number;
  type: string;
}

export default class LogReport implements ToReport<LogReporterMessage> {
  count: number;
  last: number;
  readonly data: string[];
  readonly key: string;
  readonly level: string;
  readonly ts: number;
  readonly type: string;

  private constructor(obj: LogReportInterface) {
    this.count = obj.count || 1;
    this.data = obj.data;
    this.key = obj.key;
    this.ts = obj.ts || Date.now();
    this.last = obj.last || this.ts;
    this.level = obj.level;
    this.type = obj.type;
  }

  public static create(r: ReporterMessage | LogReport): LogReport {
    if (r instanceof LogReport) {
      return new LogReport(r);
    }
    const { type, level, data } = r;
    const { msg, ts } = data;
    const [first_msg] = msg || [''];
    return new LogReport({
      data: msg,
      key: `${type}.${first_msg}`,
      level,
      type,
      ts
    });
  }

  toReport(): LogReporterMessage {
    return {
      data: {
        count: this.count,
        last: this.last,
        msg: this.data,
        ts: this.ts
      },
      level: this.level,
      type: this.type
    };
  }

  append(item: ToReport<LogReporterMessage>): void {
    const obj = item as LogReport;
    this.count += obj.count;
    this.last = obj.ts;
  }
}
